import { useParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Download, ExternalLink, BookOpen } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const bookTitles = {
  "intelligent-investor.pdf": "The Intelligent Investor",
  "psychology-of-money.pdf": "The Psychology of Money",
  "rich-dad-poor-dad.pdf": "Rich Dad Poor Dad",
  "i-will-teach-you-to-be-rich.pdf": "I Will Teach You to Be Rich",
};

const bookAuthors = {
  "intelligent-investor.pdf": "Benjamin Graham",
  "psychology-of-money.pdf": "Morgan Housel",
  "rich-dad-poor-dad.pdf": "Robert Kiyosaki",
  "i-will-teach-you-to-be-rich.pdf": "Ramit Sethi",
};

const BookPreview = () => {
  const { filename } = useParams();
  const navigate = useNavigate();
  const pdfUrl = `${API_URL}/api/resources/preview/${filename}`;
  const bookTitle = bookTitles[filename] || "Book Preview";
  const bookAuthor = bookAuthors[filename] || "";

  const handleDownload = () => {
    // Create a temporary link and trigger download
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <Button
            variant="ghost"
            onClick={() => navigate("/courses")}
            className="text-slate-600"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Products
          </Button>
        </div>
      </div>

      {/* Book Card */}
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div className="bg-white rounded-3xl shadow-xl p-8 text-center">
          <div className="w-20 h-20 bg-amber-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <BookOpen className="w-10 h-10 text-amber-600" />
          </div>
          
          <h1 className="text-3xl font-heading font-bold text-navy-700 mb-2">
            {bookTitle}
          </h1>
          <p className="text-amber-600 mb-6">by {bookAuthor}</p>
          
          <div className="bg-amber-50 rounded-xl p-4 mb-8">
            <p className="text-slate-700 font-medium">
              📖 Preview Available - First 10 Pages
            </p>
            <p className="text-slate-500 text-sm mt-1">
              This is one of the books that have made most investors rich.
            </p>
          </div>

          <div className="space-y-4">
            <Button 
              onClick={handleDownload}
              className="w-full bg-amber-500 hover:bg-amber-600 text-white h-14 text-lg"
            >
              <Download className="w-5 h-5 mr-2" />
              Download Preview PDF
            </Button>
            
            <a 
              href={pdfUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="block"
            >
              <Button 
                variant="outline"
                className="w-full border-amber-200 text-amber-700 hover:bg-amber-50 h-12"
              >
                <ExternalLink className="w-4 h-4 mr-2" />
                Open in Browser
              </Button>
            </a>
          </div>

          <div className="mt-8 pt-6 border-t border-slate-100">
            <p className="text-slate-500 text-sm">
              Want the full book? Unlock the complete bundle to access all 4 books.
            </p>
            <Button 
              variant="ghost"
              onClick={() => navigate("/courses")}
              className="mt-2 text-amber-600"
            >
              View Full Bundle →
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookPreview;
